var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"10","height":"18","viewBox":"0 0 10 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m9 17-7.35-6.586c-.867-.778-.867-2.05 0-2.828L9 1","stroke":"var(--v-primary-base)","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }